// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import { BreadcrumbGroupImplementation } from '../../../../breadcrumb-group/implementation';
import { BreadcrumbsSlotContext } from '../../contexts';
import styles from './styles.css.js';
export function BreadcrumbsSlot({ ownBreadcrumbs, discoveredBreadcrumbs }) {
    return (React.createElement(BreadcrumbsSlotContext.Provider, { value: { isInToolbar: true } },
        React.createElement("div", { className: styles['breadcrumbs-own'] }, ownBreadcrumbs),
        discoveredBreadcrumbs && (React.createElement("div", { className: styles['breadcrumbs-discovered'] },
            React.createElement(BreadcrumbGroupImplementation, Object.assign({}, discoveredBreadcrumbs, { "data-awsui-discovered-breadcrumbs": true, __injectAnalyticsComponentMetadata: true }))))));
}
//# sourceMappingURL=index.js.map